module.exports = __webpack_public_path__ + "static/instagram-4d16fdd538fde5ea06a40cf7e8cbdf30.png";